import { render, staticRenderFns } from "./AdminAddNew.vue?vue&type=template&id=3e6c893c&"
import script from "./AdminAddNew.vue?vue&type=script&lang=js&"
export * from "./AdminAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports